import Yup from "../validationsLib";

/**
 * Validations rules for the signup page of consutant
 */

export default Yup.object().shape({
    first_name: Yup.string()
        .matches(
            /^[aA-zZ\s]+$/,
            "First name cannot have numbers & special characters."
        )
        .max(30, "User should not enter more than 30 characters in this field.")
        .required("First name cannot be blank!"),

    last_name: Yup.string()
        .matches(
            /^[aA-zZ\s]+$/,
            "Last name cannot have numbers & special characters."
        )
        .max(30, "User should not enter more than 30 characters in this field.")
        .required("Last name cannot be blank!"),

    email: Yup.string()
        .email("Please enter a valid email address")
        .required("Email cannot be blank!"),

    password: Yup.string()
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,32}$/,
            "Password should contains 8-32 characters. At least 1 digit, 1 special character, 1 uppercase letter & 1 lowercase letter."
        )
        .required("Password cannot be blank!"),
    organization_name: Yup.string().required("Please enter an organisation name!"),        
    /* company_name: Yup.string()
        .matches(
            /^[aA-zZ0-9\s]+$/,
            "Company name cannot allow special characters."
        )
        .required('Company name is required'),

    website_url: Yup.string()
        .matches(/^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/, 'Invalid URL')
        .required('Website URL is required'), */
});